import { getStoredAuthenticatorUrls } from '@/modules/auth/services/adhaUaePassNative';
import { Redirect, useLocalSearchParams } from 'expo-router';
import React from 'react';

/**
 * Native UAE Pass authenticator success return: `{scheme}://uaePassSuccess`.
 * Forwards into the ADHA `/uae-pass` WebView handler.
 */
export default function UaePassSuccessRoute() {
  const params = useLocalSearchParams();
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    const raw = Array.isArray(value) ? value[0] : value;
    if (typeof raw === 'string' && raw.length > 0) {
      query.set(key, raw);
    }
  });
  const accessCode = query.get('accessCode') || query.get('access_code');
  if (accessCode && !query.get('code')) {
    query.set('code', accessCode);
  }
  if (!query.get('url') && !query.get('code')) {
    const stored = getStoredAuthenticatorUrls();
    if (stored?.successUrl) {
      query.set('adhaReturn', 'success');
      query.set('url', stored.successUrl);
    }
  }
  const qs = query.toString();
  return <Redirect href={qs ? `/uae-pass?${qs}` : '/uae-pass?adhaReturn=success'} />;
}
